module.exports = __webpack_public_path__ + "static/media/2-item-e.8aa82c12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/2-item-e.jpg
// module id = 1161
// module chunks = 33